import React, { useEffect } from "react";
import { useState } from "react";
import API from "../../services/api";
import { useNavigate } from "react-router-dom";
import ScrollContainer from "react-indiana-drag-scroll";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import { useDispatch, useSelector } from "react-redux";
import { SetComponentId } from "../../redux/counterSlice";
import invoiceSvg from '../../assets/images/invoice.svg'
import walletSvg from '../../assets/images/wallet.svg'
import {SlIcon } from "@shoelace-style/shoelace/dist/react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

export const options = {
    plugins: {
      title: {
        display: true,
        text: "Payment",
      },
    },
    responsive: true,
  };

function MyIncentives() {
  const dispatch = useDispatch();
  dispatch(SetComponentId(38));
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [incentivesData, setIncentivesData] = useState([{}]);
  const monthObj = {
    1: "Jan",
    2: "Feb",
    3: "Mar",
    4: "Apr",
    5: "May",
    6: "Jun",
    7: "Jul",
    8: "Aug",
    9: "Sep",
    10: "Oct",
    11: "Nov",
    12: "Dec",
  };
  const fetchIncentives = async () => {
    setLoader(true);
    // try {
    //   let res = await API({
    //     url: "",
    //     method: "POST",
    //     responseType: "json",
    //     data: {},
    //   });
    //   if (res.code === 200) {
    //     setIncentivesData(res.data);
    //   } else if (res.code === 401) {
    //     navigate("/");
    //   }
    // } catch (error) {
    //   console.error(error);
    // } finally {
    //   setLoader(false);
    // }
    setLoader(false);
  };
  useEffect(() => {
    fetchIncentives();
  },[]);
const data = {
    labels: ['Due', 'Paid'],
   
    datasets: [
      {
        Title:"Payment",
        label: 'Amount',
        data: [4, 12],
        backgroundColor: [
            'rgba(53, 229, 204, 1)',
          'rgba(77, 63, 209, 1)',
        ],
        borderColor: [
            'rgba(255, 255, 255, 1)',
          'rgba(255, 255, 255, 1)',
        ],
        borderWidth: 10,
      },
    ],
  };
  return (
    <div>
      <div className="d-flex gap-3 items-center">
        <h4>My Incentives</h4>
      </div>
      <div className="border rounded-lg d-flex gap-3 justify-between my-4 p-4">
            <div>
                <p>Overdue</p>
            </div>
            <span className="h-4 w-[1px] bg-gray-300"></span>
            <div>
                <p>Due with in next 30 days</p>
            </div>
            <span className="h-4 w-[1px] bg-gray-300"></span>
            <div>
                <p>Average time to get paid</p>
            </div>
            <span className="h-4 w-[1px] bg-gray-300"></span>
            <div>
                <p>Upcoming payment</p>
            </div>
      </div>
      <div className="d-flex gap-4 flex-wrap w-full">
      
      <ScrollContainer className="sm:w-[100%] md:w-[75%]">
        <table className="table table-bordered">
          <thead>
            <tr className="bg-[#F3F3F3]">
              <th>#</th>
              <th>Total Sales</th>
              <th>Delivered</th>
              <th>Invoiced</th>
              <th>Collected</th>
              <th>Incentives</th>
              <th></th>
            </tr>
          </thead>
          {incentivesData?.length && !loader ? (
            <tbody>
              {incentivesData.map((item, index) => (
                <tr>
                  <td>{monthObj[index+1]}</td>
                  <td><span className="font-semibold">&#8377;{" "}
                    </span></td>
                  <td><span className="px-2 py-1">
                  &#8377;{" "}
                    </span></td>
                  <td>
                    <div className="d-flex gap-2">
                        <img src={invoiceSvg}  className="w-4 h-4" alt="invoice"></img>
                        &#8377;
                    </div>
                  </td>
                  <td>
                    <div className="d-flex gap-2 items-center">
                    <SlIcon library="lucide" className="" name={`${ 1 > 2 ? 'arrow-down' : 'arrow-up'}`}></SlIcon>
                    <span className="font-semibold">&#8377;{" "}{2000}
                    </span>
                    </div>
                  </td>
                  <td>
                  <div className="d-flex gap-2">
                        <img src={walletSvg} className="w-4 h-4" alt="invoice"></img>
                        &#8377;
                    </div>
                  </td>
                  <td>To be paid in 30 days</td>
                </tr>
              ))}
            </tbody>
          ) : !incentivesData?.length && !loader ? (
            <NoDataFound colspan="7" />
          ) : (
            <TableLoader colspan="7" />
          )}
        </table>
      </ScrollContainer>
        <div className="border rounded-lg p-3 sm:w-[100%] md:w-[23%] mx-auto">
        <Pie data={data} className="md:w-[200px] sm:w-[100px] mx-auto" options={options}/>
        </div>
      </div>
    </div>
  );
}

export default MyIncentives;
